export var UsVaField;
(function (UsVaField) {
    UsVaField["VERSION"] = "Version";
    UsVaField["SHARING_NOTICE"] = "SharingNotice";
    UsVaField["SALE_OPT_OUT_NOTICE"] = "SaleOptOutNotice";
    UsVaField["TARGETED_ADVERTISING_OPT_OUT_NOTICE"] = "TargetedAdvertisingOptOutNotice";
    UsVaField["SALE_OPT_OUT"] = "SaleOptOut";
    UsVaField["TARGETED_ADVERTISING_OPT_OUT"] = "TargetedAdvertisingOptOut";
    UsVaField["SENSITIVE_DATA_PROCESSING"] = "SensitiveDataProcessing";
    UsVaField["KNOWN_CHILD_SENSITIVE_DATA_CONSENTS"] = "KnownChildSensitiveDataConsents";
    UsVaField["MSPA_COVERED_TRANSACTION"] = "MspaCoveredTransaction";
    UsVaField["MSPA_OPT_OUT_OPTION_MODE"] = "MspaOptOutOptionMode";
    UsVaField["MSPA_SERVICE_PROVIDER_MODE"] = "MspaServiceProviderMode";
})(UsVaField || (UsVaField = {}));
export const USVA_CORE_SEGMENT_FIELD_NAMES = [
    UsVaField.VERSION,
    UsVaField.SHARING_NOTICE,
    UsVaField.SALE_OPT_OUT_NOTICE,
    UsVaField.TARGETED_ADVERTISING_OPT_OUT_NOTICE,
    UsVaField.SALE_OPT_OUT,
    UsVaField.TARGETED_ADVERTISING_OPT_OUT,
    UsVaField.SENSITIVE_DATA_PROCESSING,
    UsVaField.KNOWN_CHILD_SENSITIVE_DATA_CONSENTS,
    UsVaField.MSPA_COVERED_TRANSACTION,
    UsVaField.MSPA_OPT_OUT_OPTION_MODE,
    UsVaField.MSPA_SERVICE_PROVIDER_MODE,
];
